/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityByComponent {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilityByComponent.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityByComponent>): AppSecopsVulnerabilityByComponent {
        let obj = Object.assign(new AppSecopsVulnerabilityByComponent(), model);
        AppSecopsVulnerabilityByComponent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityByComponent>): AppSecopsVulnerabilityByComponent {
        if (!model) return null;
        return AppSecopsVulnerabilityByComponent.newInstance(<AppSecopsVulnerabilityByComponent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityByComponent) {
        if (!obj) return;

        models.AppSecopsVulnerabilityByComponent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityByComponent): boolean {
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityByComponent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
    }

    /**
     * Time range bucket for grouping vulnerabilities based on NVD published date or SBOM created date
     */
    days_range: models.DaysRange;

    /**
     * SBOM component Product name
     */
    product: string;

    /**
     * SBOM component Vendor name
     */
    vendor: string;

    /**
     * SBOM component package type
     */
    package_type: string;

    /**
     * Severity of the vulnerability
     */
    severity: models.Severity;

    /**
     * Indicates whether the vulnerability is a Known Exploited Vulnerability (KEV)
     */
    is_kev: boolean;

    /**
     * Total count of vulnerabilities associated with the category
     */
    count: number;

    /**
     * List of vulnerability IDs associated with the component
     */
    vulnerability_ids: Array<string>;

}
